import constants from './constants';

const initState = {
  createNewDevice: {
    name: '',
    client: '',
    business_type_id: '',
    device_type_id: [],
    slvdl: '',
    gateway_id: '',
  },
  deviceIdToEdit: null,
  idBusinessType: null,
  createNewGateway: {
    name: '',
    mac: '',
    state: 'normal',
    fw_assigned_id: '',
    portal_assigned_id: '',
    latitude: 0,
    longitude: 0,
    hwInt: '',
    baud: '',
    ival: '',
    device_api_key_id: [],
  },
  gatewayIdToEdit: null,
  logsDevices: {
    device: '',
    resetStatus: '',
    systemStatus: 0,
    date: '',
  },
  deviceList: null,
  offset: 0,
  limit: 40,
  count: null,
  createEditValues: null,
  search: '',
  isEditDefault: false,
  idsInDeleting: [],
};

function devicesReducer(state = initState, { type, payload }) {

  switch (type) {

    case constants.SET_CREATE_EDIT_DEVICES:
      return {
        ...state,
        createNewDevice: payload,
      };

    case constants.SET_DEVICES_ID_TO_EDIT:
      return {
        ...state,
        deviceIdToEdit: payload,
      };
    case constants.SET_ID_BUSINESS_TYPE:
      return {
        ...state,
        idBusinessType: payload,
      };
    case constants.SET_CREATE_EDIT_GATEWAY:
      return {
        ...state,
        createNewGateway: payload,
      };

    case constants.SET_GATEWAY_ID_TO_EDIT:
      return {
        ...state,
        gatewayIdToEdit: payload,
      };

    case constants.SET_DEVICES_LOGS:
      return {
        ...state,
        logsDevices: payload,
      };
    case constants.SET_IS_EDIT_DEFAULT:
      return {
        ...state,
        isEditDefault: payload,
      };

    case constants.RESET_DEVICES:
      return {
        ...state,
        deviceList: null,
        offset: 0,
        count: null,
      };

    case constants.SET_SEARCH:
      return {
        ...state,
        search: payload,
      };

    case constants.RESET_OFFSET:
      return {
        ...state,
        offset: 0,
        count: null,
      };

    case constants.SET_DEVICES_LIST:
      return {
        ...state,
        deviceList: payload.deviceList,
        offset: payload.offset,
        count: payload.count,
      };

    case constants.EDIT_DEVICE:
      return {
        ...state,
        deviceList: payload,
      };

    case constants.SET_DEVICE_LIST:
      return {
        ...state,
        deviceList: payload,
      };

    case constants.START_DELETING_DEVICE:
      return {
        ...state,
        idsInDeleting: payload,
      };

    case constants.ADD_DEVICE:
    case constants.DELETE_DEVICE:
      return {
        ...state,
        deviceList: payload.deviceList,
        count: payload.count,
        idsInDeleting:
          payload.idsInDeleting !== undefined ? payload.idsInDeleting : state.idsInDeleting,
      };

    case constants.SET_DEVICE_COUNT:
      return {
        ...state,
        count: payload,
      };

    case constants.SET_CREATE_EDIT_VALUES:
    case constants.ADD_CREATE_EDIT_VALUES_GROUP_CONDITIONS:
    case constants.REMOVE_CREATE_EDIT_VALUES_GROUP_CONDITIONS:
    case constants.ADD_CREATE_EDIT_VALUES_OR_CONDITION:
    case constants.REMOVE_CREATE_EDIT_VALUES_OR_CONDITION:
    case constants.CHANGE_CREATE_EDIT_VALUES_OR_CONDITION:
    case constants.ADD_CREATE_EDIT_VALUES_ACTION:
    case constants.REMOVE_CREATE_EDIT_VALUES_ACTION:
    case constants.CHANGE_CREATE_EDIT_VALUES_ACTION:
      return {
        ...state,
        createEditValues: payload,
      };

    default:
      return state;

  }

}

export default devicesReducer;
